// removed by extract-text-webpack-plugin
module.exports = {"searchResult":"searchResult--2wEGI","title":"title--30QdS","url":"url--2T7xy","description":"description--3FWUv"};